window.addEventListener('load', function () {
  var banner_container = document.querySelector(
    '.yotpo-widget-hero-section .yotpo-text-container'
  );

  if (banner_container) {
    var banner_template = document.querySelector('#BannerTitle');

    if (banner_template.content.firstElementChild) {
      banner_container.insertAdjacentElement(
        'afterbegin',
        banner_template.content.firstElementChild.cloneNode(true)
      );
    }
  }

  var visual_container = document.querySelector(
    '.yotpo-widget-visual-redemption-widget .yotpo-headline'
  );

  if (visual_container) {
    var visual_template = document.querySelector('#VisualIcons');

    if (visual_template.content.firstElementChild) {
      visual_container.insertAdjacentElement(
        'afterend',
        visual_template.content.firstElementChild.cloneNode(true)
      );
    }
  }

  var visual_container = document.querySelector(
    '.yotpo-coupons-redemption-widget .yotpo-headline'
  );

  if (visual_container) {
    var visual_template = document.querySelector('#VisualIcons');

    if (visual_template.content.firstElementChild) {
      visual_container.insertAdjacentElement(
        'afterend',
        visual_template.content.firstElementChild.cloneNode(true)
      );
    }
  }

  var share_container = document.querySelector(
    '.yotpo-share-buttons-container'
  );

  if (share_container) {
    var email_template = document.querySelector('#EmailIcon');
    var copy_template = document.querySelector('#CopyIcon');
    var facebook_template = document.querySelector('#FacebookIcon');
    var messenger_template = document.querySelector('#MessengerIcon');
    var whatsapp_template = document.querySelector('#WhatsappIcon');

    var share_button = share_container.querySelector(
      '.yotpo-email-share-button .yotpo-share-button-icons'
    );

    if (share_button) {
      share_button.replaceChildren(
        email_template.content.firstElementChild.cloneNode(true)
      );
    }

    share_container
      .querySelector('.yotpo-share-button .yotpo-share-button-icons')
      .replaceChildren(copy_template.content.firstElementChild.cloneNode(true));
    share_container
      .querySelector('.yotpo-facebook-share-button .yotpo-share-button-icons')
      .replaceChildren(
        facebook_template.content.firstElementChild.cloneNode(true)
      );
    share_container
      .querySelector(
        '.yotpo-facebook-messenger-share-button .yotpo-share-button-icons'
      )
      .replaceChildren(
        messenger_template.content.firstElementChild.cloneNode(true)
      );
    share_container
      .querySelector('.yotpo-whatsapp-share-button .yotpo-share-button-icons')
      .replaceChildren(
        whatsapp_template.content.firstElementChild.cloneNode(true)
      );
  }

  var rewards_container = document.querySelector(
    '.yotpo-widget-my-rewards-widget'
  );

  if (rewards_container) {
    banner_container.appendChild(rewards_container);
  }

  document.querySelector('.yotpo-rewards').classList.add('loaded');
});
